import FormEventNew from "../components/forms/FormEventNew/FormEventNew";
import Breadcrumbs from "../components/layout/BreadCrumbs";
import PageLayout from "../components/layout/PageLayout/PageLayout";
import { useFetchSitesQuery } from "../features/api/apiSlice";

const PageNewEvent = () => {
  const { data: sitesData } = useFetchSitesQuery();

  return (
    <PageLayout>
      <Breadcrumbs pageName="newEvent" />
      <FormEventNew sites={sitesData?.results} />
    </PageLayout>
  );
};

export default PageNewEvent;
